import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { CustomerService } from "../shared/customer.service";
import { Customer } from "../shared/customer.model";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { PrivilegeService } from "../../staff/Shared/privilege.service";

import { ConfirmationdialogService } from "../../utility/shared/confirmationdialog.service";
import { ToasterserviceService } from "../../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../../utility/shared/toastpayload";

@Component({
  selector: 'app-customerlist',
  templateUrl: './customerlist.component.html',
  styleUrls: ['./customerlist.component.css']
})

export class CustomerlistComponent implements OnInit {

  IsAdd: boolean;
  IsEdit: boolean;
  IsDelete: boolean;
  IsView: boolean;
  IsPrint: boolean;
  toast: Toastpayload;

  displayedColumns: string[] = [
    'Id', 'CustomerNo', 'Name', 'Center', 'Address', 'Mobile', 'AadharNo', 'New']; //'Guardian',

  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  customer = new Customer();

  constructor(private router: Router, public customerService: CustomerService,
    private ngxLoader: NgxUiLoaderService,
    private privilegeService: PrivilegeService,
    private toasterserviceService: ToasterserviceService,
    private confirmationdialogService: ConfirmationdialogService,
  ) { }

  ngOnInit() {
    this.Customerlist();
    this.dataSource.paginator = this.paginator;
  }

  public AddNewCustomer() {
    this.router.navigate(['/customer']);
  }

  Customerlist() {

    // showing Loader 
    this.ngxLoader.start();

    this.customerService.FetchCustomerList().subscribe(data => {
      // this.EnquiryEntryList$=data;
      this.dataSource.data = data;
    })

    // Closing Loader
    this.ngxLoader.stop();
  }

  EditCustomers(customerRow: any) {
    // this.router.navigate(['/customer', customerRow.Id]);
    this.router.navigate(['/customer', { Id: customerRow.Id, Id1: undefined }]);
  }

  // old code
  // DeleteCustomer(RowAction : any, RowId : Customer){

  // const result = confirm("Are you sure to delete " + RowId.FirstName);
  // if (result) {

  //   this.customer = RowId;
  //   this.customer.Flag = 2;
  //   this.customerService.IUDCustomer(this.customer);
  // } else {
  //   console.log("NO")
  // }
  // }

  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }

  // Delete Ledger with Toastr messsage
  DeleteCustomer(element: any) {

    this.toast = {
      message: "The customer have been deleted",
      title: 'Customer deletion',
      ic: {
        timeOut: 3000,
        closeButton: true,
      } as IndividualConfig,
      type: 'success',
    };

    let title: string = "Confirmation";
    // let message: string = "If you continue, the customer will be removed. Are you sure? ";
    // let btnOkText: string = "Yes";
    // let btnCancelText: string = 'No, Exit';
    let message: string = "You dont have the permission to delete the customer, Please contact admin";
    let btnOkText: string = "Ok";
    let btnCancelText: string = 'Exit';

    this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed =>
      // console.log('User confirmed:', confirmed)
      {
        if (confirmed == true) {
          // centrelink deletion
          // this.IUDCustomer(element); --# on 15-08-2025, temperorly commented.
          this.toast.message = 'Please contact administrator for customer deletion.!'
          this.toast.type = 'warning';
          this.toasterserviceService.showToast(this.toast);
        }
        else {

          console.log(confirmed);
          this.toast.message = 'You are cancelled the customer deletion.!'
          this.toast.type = 'warning';
          this.toasterserviceService.showToast(this.toast);
        }
      });
  }

  // Customer delete action
  IUDCustomer(element: any): any {

    this.customerService.selectedCustomer = new Customer;
    this.customerService.selectedCustomer.Id = element.Id;  // CustomerId
    this.customerService.selectedCustomer.IsActive = false;  // deactivate
    this.customerService.selectedCustomer.Flag = 3; // deactivate Flag

    // IUD, delete action
    const promiseValue = new Promise<Boolean>((resolve, reject) => {

      this.customerService.IUDCustomer(this.customerService.selectedCustomer)
        .toPromise()
        .then(data => {
          // console.log(data)
          if(data.ResponseId != 200){
            return false;
          }
          else{
            // this.ngOnInit();
            return true;
          }

        })
        .catch(err => { console.log(err); reject(false) });

      resolve(true);
    });

    promiseValue.then((value) => {
      if(value){      
        this.ngOnInit();
      }
      else{
        this.toast.message = 'customer deletion failed.!'
        this.toast.type = 'error';
        this.toasterserviceService.showToast(this.toast);
      }

    });
  }

}


